module.exports = __webpack_public_path__ + "static/media/allergies.3fb0c694.svg";